var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.85 7.24999L9.24997 17.85C9.15609 17.9447 9.02829 17.9979 8.89497 17.9979C8.76166 17.9979 8.63386 17.9447 8.53997 17.85L3.14997 12.46C3.05532 12.3661 3.00208 12.2383 3.00208 12.105C3.00208 11.9717 3.05532 11.8439 3.14997 11.75L3.84997 11.05C3.94386 10.9553 4.07166 10.9021 4.20497 10.9021C4.33829 10.9021 4.46609 10.9553 4.55997 11.05L8.88997 15.38L18.44 5.82999C18.6378 5.63821 18.9522 5.63821 19.15 5.82999L19.85 6.53999C19.9446 6.63388 19.9979 6.76168 19.9979 6.89499C19.9979 7.02831 19.9446 7.15611 19.85 7.24999Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/done.6bde1ed7.svg";
export { ForwardRef as ReactComponent };